import { render, staticRenderFns } from "./UploadButton.vue?vue&type=template&id=8a2157fa&scoped=true"
import script from "./UploadButton.vue?vue&type=script&lang=js"
export * from "./UploadButton.vue?vue&type=script&lang=js"
import style0 from "./UploadButton.vue?vue&type=style&index=0&id=8a2157fa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2157fa",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/UploadButton.vue
// module id = 1563
// module chunks = 31